import type {
  GenerateQuoteAttachmentUploadInput,
  GenerateQuoteAttachmentUploadOutput,
  MarkQuoteSmsFailedOutput,
  StartQuoteRequestInput,
  StartQuoteRequestOutput,
  VerifyQuoteOtpInput,
  VerifyQuoteOtpOutput,
} from '@mbbe/types';
import { apiFetch } from '../../lib/apiClient';
import { getCurrentAttributionPayload } from '../../lib/attribution';

interface MarkQuoteSmsFailedDetails {
  error?: {
    code?: string;
    message?: string;
    name?: string;
  };
  markFailed?: boolean;
}

export function startQuoteRequest(input: Omit<StartQuoteRequestInput, 'attribution'>) {
  const attribution = getCurrentAttributionPayload();
  return apiFetch<StartQuoteRequestOutput>('/quote-requests/start', {
    method: 'POST',
    body: JSON.stringify({ ...input, attribution: Object.keys(attribution).length > 0 ? attribution : undefined }),
  });
}

export function verifyQuoteOtp(input: VerifyQuoteOtpInput) {
  return apiFetch<VerifyQuoteOtpOutput>('/quote-requests/verify', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function markQuoteSmsFailed(quoteRequestId: string, input?: MarkQuoteSmsFailedDetails) {
  return apiFetch<MarkQuoteSmsFailedOutput>(`/quote-requests/${quoteRequestId}/sms-failed`, {
    method: 'POST',
    body: JSON.stringify(input ?? {}),
  });
}

export function generateQuoteAttachmentUpload(input: GenerateQuoteAttachmentUploadInput) {
  return apiFetch<GenerateQuoteAttachmentUploadOutput>('/quote-requests/attachments/presign', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
